import * as React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';
import { Shop } from '../../types/shops';

interface Props {
  onClick: () => void;
  shop: Shop;
  showUpdated: boolean;
}

const ModalShopRow: React.FC<Props> = ({ onClick, shop, showUpdated }) => {
  const { id, name } = shop;

  return (
    <Flex alignItems="center" data-testid={`shop-item-${id}`} justifyContent="space-between" p={3}>
      <Flex>
        <Text className="notranslate">{name}</Text>
      </Flex>
      <Flex alignItems="center">
        {showUpdated && (
          <Text
            color="gray-400"
            data-testid={`shop-just-updated-${id}`}
            mx={3}
            size="small"
            textAlign="right"
          >
            Just updated
          </Text>
        )}
        <Button data-testid={`remove-shop-btn-${id}`} fill onClick={onClick}>
          Remove
        </Button>
      </Flex>
    </Flex>
  );
};

export default ModalShopRow;
